import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import connectDisplayerContainer from 'customizer/2dDisplayer/connectDisplayerContainer'
import * as twoDDisplayerActions from 'customizer/2dDisplayer/actions'
import * as twoDDisplayerSelectors from 'customizer/2dDisplayer/selectors'
import * as towDDisplayerHooks from 'customizer/2dDisplayer/hooks/index'
import Displayer from 'customizer/2dDisplayer/components/Displayer'
import useThemeSettings from 'customizer/theme/useThemeSettings'
import PoweredByKickflip from 'themes/common/components/PoweredByKickflip'
import EmptyProduct from 'themes/common/components/EmptyProduct'
import OverlayLoading from 'themes/common/components/OverlayLoading'
import PreviousView from 'themes/common/components/controls/PreviousView'
import NextView from 'themes/common/components/controls/NextView'
import DisplayerTopSection from './section/DisplayerTopSection'
import DisplayerBottomSection from './section/DisplayerBottomSection'

import './DisplayerContainer.scss'
import { ConnectedDisplayerContainerProps } from 'customizer/2dDisplayer/connectDisplayerContainer'

export type DisplayerContainerProps = {
  hideFinish?: boolean
}

const DisplayerContainer = (props: DisplayerContainerProps & ConnectedDisplayerContainerProps) => {
  const { isReady, isEmpty, whiteLabel, views = 0, previousView, nextView } = props
  const dispatch = useDispatch()
  const showViewControls = views > 1
  const { backgroundColor } = useThemeSettings('customizer')
  const isRenderCompleted = useSelector(twoDDisplayerSelectors.isRenderCompletedSelector)

  const handleFirstRenderCompleted = () => dispatch(twoDDisplayerActions.updateRenderState(true))

  const { previousViewWithDirection, nextViewWithDirection, switchViewDirection } =
    towDDisplayerHooks.useSwitchViewWithDirection(previousView, nextView)

  if (isReady && isEmpty) {
    return <EmptyProduct onLoadingCompleted={handleFirstRenderCompleted} />
  }

  return (
    <>
      {!isRenderCompleted && <OverlayLoading />}
      <div className="displayer-container" style={{ backgroundColor }}>
        {showViewControls && <PreviousView onClick={previousViewWithDirection} />}

        <div className="displayer-area">
          {isReady && (
            <>
              <DisplayerTopSection {...props} />
              <Displayer
                {...props}
                handleFirstRenderCompleted={handleFirstRenderCompleted}
                switchViewDirection={switchViewDirection.current || ''}
                nextView={nextViewWithDirection}
                previousView={previousViewWithDirection}
              />
              <DisplayerBottomSection {...props} />
            </>
          )}
        </div>
        {showViewControls && <NextView onClick={nextViewWithDirection} />}
      </div>
      {isReady && !whiteLabel && <PoweredByKickflip />}
    </>
  )
}

export default connectDisplayerContainer(DisplayerContainer)
